const resumo_do_reordenamento = {
  path: "/resumo-do-reordenamento",
  redirect: "/resumo-do-reordenamento",
  meta: {
    breadCrumb: "Processo de Matrículas - Reordenamento",
  },
  children: [
    {
      path: "/resumo-do-reordenamento",
      name: "resumo_do_reordenamento",
      component: () =>
        import("@/views/ResumoDoReordenamento/ResumoDoReordenamentoHome.vue"),
    },
  ],
};

export { resumo_do_reordenamento };
